import { useEffect } from 'react'
import { useAuth } from '../auth/AuthContext'
import { startWebMcp } from '../lib/webmcp'
import { useStorageBackend } from '../persistence/StorageContext'

/**
 * Exposes LightScape's tools to the browser's WebMCP agent once per signed-in person, and
 * unregisters them on sign-out or person change. Renders nothing.
 */
export function WebMcpBridge() {
  const { status, user } = useAuth()
  const { kind } = useStorageBackend()
  const sub = status === 'authenticated' ? user?.profile.sub : undefined

  useEffect(() => {
    if (!sub || kind !== 'server') return
    const controller = new AbortController()
    startWebMcp(controller.signal).catch((error: unknown) => {
      if (!controller.signal.aborted) console.warn('[webmcp] bridge failed to start', error)
    })
    return () => controller.abort()
  }, [sub, kind])

  return null
}
